import { gsap } from "gsap";

export default class Intro {
    constructor() {
        this.ua = window.navigator.userAgent.toLowerCase();
        this.init();
    }

    init() {
        this.intro();
    }

    skippedAnimation() {}

    intro() {
        const tl = new gsap.timeline({});
        tl.fromTo(".mainvisual__ttl", 2, { opacity: 0, scale: 1.1 }, { opacity: 1, scale: 1 }, 0.5);
    }
}
